var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "common-card-top" }, [
      _c("div", { staticClass: "card_t_l" }, [
        _c("div", { staticClass: "title" }, [_vm._v("Current round details")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "total" },
          [
            _vm._v("You have stake/Total :\n        "),
            _c("big-number", { attrs: { number: _vm.myBidNum } }),
            _vm._v("\n        /\n        "),
            _c("big-number", { attrs: { number: _vm.total } }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card_t_r" },
        [_c("TopTime", { on: { finish: _vm.getData } })],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "common-card-main" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "common-table",
            attrs: { data: _vm.tableList, height: "6rem" },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "roundTime", label: "Round Block" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Account" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_c("Account", { attrs: { value: row.bider } })]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Block", align: "right" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v("\n          " + _vm._s(row.time) + "\n        "),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Cumulative Staked ", align: "right" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("big-number", { attrs: { number: row.amount } }),
                      _vm._v(" "),
                      _c("span", { staticClass: "td-word-sm" }, [
                        _vm._v("REP"),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }